import { colors, responsive } from '@/utils';

export const tabsInset = responsive.spacing['2xlarge'];

export const tabsLayout = {
  verticalRailWidth: '11.5rem',
  tabHeight: '2.25rem',
} as const;

export const tabsColors = {
  rootBackground: colors.background.transparent[0],
  divider: colors.stroke.neutral[50],

  tabSurface: {
    default: {
      color: colors.icon.neutral.contrast,
      background: colors.background.transparent[0],
    },
    hover: {
      color: colors.text.neutral.contrast,
      background: colors.background.action.soft[100],
    },
    disabled: {
      color: colors.text.disabled,
      background: colors.background.disabled,
    },
    selected: {
      color: colors.text.neutral.contrast,
      background: colors.background.action.soft[300],
      hover: {
        color: colors.text.neutral.contrast,
        background: colors.background.action.soft[200],
      },
    },
  },
  tabFocusOutline: colors.stroke.action.solid[200],
} as const;
